<template>
  <div class="amazon_edit" style="width: 90%">
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <div id="main">
      <el-form ref="basicForm" label-width="200px" :model="basicForm">
        <div class="basic">
          <div>
            <div id="basic" class="title">基本信息</div>

            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="店铺："
            >
              <el-select
                clearable
                :disabled="templateId.length > 0"
                class="wd600"
                size="mini"
                v-model="basicForm.templateState"
                placeholder="请选择模板国家"
                @change="handleChangeState"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="platId"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="分类："
            >
              <el-cascader
                class="wd600"
                size="mini"
                expand-trigger="hover"
                :options="platTypeList"
                :props="optionProps"
                v-model="basicForm.platId"
                @change="handleChangePlatId"
                :disabled="templateId.length > 0"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="产品名称："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="供应商链接："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <el-button slot="append">复制链接</el-button>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <div id="product" class="title">产品信息</div>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="Parent SKU："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              ></el-input>
            </el-form-item>
            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="产品描述："
            >
              <el-input
                size="mini"
                v-model="basicForm.templateName"
                maxlength="3000"
                show-word-limit
                :rows="10"
                type="textarea"
              ></el-input>
            </el-form-item>
          </div>
          <div>
            <div id="safe" class="title">销售信息</div>
            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="产品类型："
            >
              <el-radio-group v-model="basicForm.saleForm">
                <template v-for="record in dictData['sale_form']">
                  <el-radio :label="record.value" :key="record.value">
                    {{ record.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="价格："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">PHP </span>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="促销价："
            >
              <span slot="label"
                >促销价：
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="只展示进行中或未进行的活动"
                  placement="top-start"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="库存："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="批发价："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
          </div>
          <div>
            <div id="safe" class="title">销售信息</div>
            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="产品类型："
            >
              <el-radio-group v-model="basicForm.saleForm">
                <template v-for="record in dictData['sale_form']">
                  <el-radio :label="record.value" :key="record.value">
                    {{ record.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="价格："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">PHP </span>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="促销价："
            >
              <span slot="label"
                >促销价：
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="只展示进行中或未进行的活动"
                  placement="top-start"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </span>
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="库存："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="批发价："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
              </el-input>
            </el-form-item>
          </div>
          <div>
            <div id="safe" class="title">媒体</div>
            <el-form-item style="margin-bottom: 0" label="产品图片：">
              <span class="form-label" slot="label">
                <span style="color: red; margin: 0 5px 0 0">*</span>产品图片：
              </span>
              <div class="image-hint" style="position: relative">
                <div>
                  点击图片拖动，即可调整图片顺序！
                  [图片最多选择9张，已经选择了{{ imageGroup.length }}张]
                </div>
              </div>
              <div
                v-if="false"
                style="
                display: inline-block;
                margin: 0 0 0 8px;
                position: relative;
              "
                @click="showPicSize = true"
              >
                <span style="right: 10px; top: -2px; color: #409eff">
                  <span class="size_name_style is_main active"
                    ><span
                      ><i
                        class="el-icon-full-screen"
                        style="margin: 0 4px 0 0"
                      ></i
                      >尺寸调整（{{ basicForm.picSizeW }} x
                      {{ basicForm.picSizeH }}px）
                      <i
                        class="icon-screen_low f14 pa"
                        style="top: 0px; right: -14px"
                      ></i>
                    </span>
                  </span>
                </span>
              </div>
              <div
                v-if="showPicSize"
                style="
                position: absolute;
                left: 0px;
                top: 117px;
                z-index: 100;
                padding: 8px;
              "
                class="imgSize-box active is_main"
              >
                <div class="cont">
                  <el-radio-group style="display: block" v-model="sizeConfig">
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1600"
                      >1600 x 1600px(默认)</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="800"
                      >800 x 800px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="1200"
                      >1200 x 1200px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0"
                      :label="2000"
                      >2000 x 2000px</el-radio
                    >
                    <el-radio
                      style="display: block; margin: 16px 0 0 0"
                      :label="0"
                      >自定义</el-radio
                    >
                  </el-radio-group>
                  <div v-if="sizeConfig == 0">
                    <input
                      placeholder="宽度"
                      v-model="picSizeW"
                      style="width: 60px; line-height: 24px; margin: 0 16px 0 0"
                    />
                    x
                    <input
                      v-model="picSizeH"
                      placeholder="高度"
                      style="width: 60px; line-height: 24px"
                    />
                  </div>
                </div>
                <div class="foot" style="text-align: center">
                  <el-button @click="showPicSize = false" size="small"
                    >取消</el-button
                  >
                  <el-button
                    size="small"
                    @click="handleSavePicSize"
                    type="primary"
                    >保存</el-button
                  >
                </div>
              </div>
              <ul
                class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
              >
                <draggable
                  :list="imageGroup"
                  style="overflow: hidden; display: inline-block"
                  filter=".forbid"
                  @start="drag = true"
                  @end="drag = false"
                  :move="onMove"
                >
                  <li
                    v-for="(record, index) in imageGroup"
                    :key="index"
                    class="sort-img-item"
                    :class="index === 0 ? 'forbid' : ''"
                  >
                    <p v-if="record.imageUrl.indexOf('http') === -1">
                      效果图{{ record.imageUrl }}
                    </p>
                    <img v-else :src="record.imageUrl" />
                    <span class="first-pro-icon icon-corner-mark"></span>
                    <div class="wish-product-img-ope">
                      <a
                        @click.prevent="hanldeDeleteImage(record, index)"
                        class="set-delete"
                        >移除</a
                      >
                    </div>
                  </li>
                </draggable>
                <li
                  class="forbid"
                  :class="{ 'add-image-button': true }"
                  v-if="imageGroup.length < 9"
                >
                  <p><i class="el-icon-plus"></i></p>
                  <div class="variable-select-box">
                    <ul>
                      <li @click="handleUploadImage">本地图片</li>
                    </ul>
                  </div>
                </li>
              </ul>
            </el-form-item>
            <el-form-item class="wd100" label="视频：">
              <el-button size="small" type="primary">添加视频</el-button>
              <div class="flex">
                <div style="margin: 16px 0 0 0;" class="lt mr_20">
                  <div class="pro_vid_box">
                    <i class="el-icon-video-camera st_el"></i>
                  </div>
                </div>
                <div class="rt">
                  <p class="f_gray">
                    1. 大小：最大 30Mb, 像素不可超过 1280x1280px
                  </p>
                  <p class="f_gray">2. 时长：10s-60s</p>
                  <p class="f_gray">3. 格式：MP4</p>
                  <p class="videoTip hide">
                    <i class="bsicon_light_bulb f_green mr_5"></i>
                    <span class="f_gray"
                      >请在视频上传后7天内发布产品，否则视频会被自动删除。</span
                    >
                  </p>
                </div>
              </div>
            </el-form-item>
          </div>
          <div>
            <div id="desc" class="title">物流</div>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="运费："
            >
              <el-input
                class="wd600"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">PHP </span>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="重量："
            >
              <el-input
                class="wd200"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="suffix">kg</span>
              </el-input>
            </el-form-item>
            <el-form-item
              prop="templateName"
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              label="包装尺寸："
            >
              <el-input
                class="wd200 mr8"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">宽</span>
                <span slot="suffix">cm</span>
              </el-input>
              <el-input
                class="wd200 mr8"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">长</span>
                <span slot="suffix">cm</span>
              </el-input>
              <el-input
                class="wd200 mr8"
                :disabled="templateId.length > 0"
                size="mini"
                v-model="basicForm.templateName"
              >
                <span slot="prefix">高</span>
                <span slot="suffix">cm</span>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <div id="desc" class="title">其他</div>
            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="是否预购："
            >
              <el-radio-group v-model="basicForm.saleForm">
                <template v-for="record in dictData['sale_form']">
                  <el-radio :label="record.value" :key="record.value">
                    {{ record.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              :rules="[
                { required: true, message: '请输入内容', trigger: 'blur' },
              ]"
              prop="templateState"
              label="物品状况："
            >
              <el-radio-group v-model="basicForm.saleForm">
                <template v-for="record in dictData['sale_form']">
                  <el-radio :label="record.value" :key="record.value">
                    {{ record.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <div class="sidebar__style">
        <div class="list__style">
          <div><a class="text-link" href="#basic">基本信息</a></div>
          <div><a class="text-link" href="#product">产品信息</a></div>
          <div><a class="text-link" href="#safe">质保信息</a></div>
          <div><a class="text-link" href="#desc">描述</a></div>
        </div>
        <div @click="handleBackTop" class="button__style goTop__style">
          返回<br />顶部
        </div>
        <div @click="handleSave" class="button__style submit__style">
          保存<br />产品
        </div>
      </div>
    </div>
    <VarHelp ref="varHelp" v-show="showVarHelp"></VarHelp>
    <PriceConfigDialog
      v-model="priceConfigVisible"
      @update="handleSetPrice"
    ></PriceConfigDialog>
    <SizeColorDialog
      :colorList="basicForm.colorList"
      :sizeList="basicForm.sizeList"
      v-model="sizeColorVisible"
      @update="handleSetColorSize"
    ></SizeColorDialog>
  </div>
</template>

<script type="text/ecmascript-6">
import BasicControl from "./basicControl";
import { getProList } from "@/api/plat/platType";
import Breadcrumb from "@/components/common/Breadcrumb";
import { mapGetters } from "vuex";
import { getProductTypeList, getTemplateTypeList } from "@/api/plat/platType";
import { addTemplate, getTemplateInfo, addRemit, addAmazonRemit, getVarListDesign, getVarListColl, getVarList, listDesignColorsize, listAmazonColorsize } from "@/api/template/template";
import { getOSSToken } from "@/api/setting";
import { getConfigKey } from "@/api/system/config";
import VarHelp from './varHelp.vue'
import PriceConfigDialog from './PriceConfigDialog'
import SizeColorDialog from './SizeColorDialog'
import draggable from "vuedraggable"
import { getDomainList, } from "@/api/system/domain"
import CKEditor4 from '@/components/common/CKEditor'

export default {
  name: "templateShopee",
  components: { BasicControl, Breadcrumb, VarHelp, PriceConfigDialog, SizeColorDialog ,draggable, CKEditor4 },
  props: {
    templateId : {
      type : String,
      default: ''
    },
    shopId : {
      type : String,
      default: ''
    },
    designId : {
      type : String,
      default: ''
    }
  },
  data() {
    return {
      basicForm: {
        templateName: "",
        templateState: "US",
        saleForm: "03",
        platId: "",
        productPicAddr: "",
        exportFormat: "xlsx",
        attrList: [],
        price: '',
        quantity: '',
        skuList: [],
        external_product_id_type: '',
        external_product_id: '',
        color_name: '',
        groupNum: '',
        colorList: [],
        sizeList: [],
        picSizeH: '1600',
        picSizeW: '1600'
      },
      editorConfig:{
            // extraPlugins:'myplug',
            height:'200px',
            toolbar : [
                [ 'Source','Maximize'],
                [ 'Bold', 'Italic', 'Underline', 'Strike'],
                [ 'TextColor', 'BGColor' ],
                [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                [ 'HorizontalRule','RemoveFormat'],
                ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                '/',
                [ 'Styles', 'Format', 'Font', 'FontSize' ],
                [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                [ 'Link', 'Unlink','-' ,'Image']
            ],
            language: 'zh-cn',
            wordcount:{
                showCharCount: true,
            }
      },
      editorRemarks:'',
      formItems: [],
      groups: [],
      forms: [],
      templateViews: ["Required" , "必須"],
      checkedAll: false,
      importTypeMap: {
        Required: "重要",
        Optional: "可选",
        Preferred: "首选",
      },
      platTypeList: [],
      optionProps: {
        value: "platId",
        label: "platName",
        children: "childrenTree",
      },
      feedProductType: "",
      itemType: "",
      imageGroup: [],
      imageSamples: ["1","2","3","4","5","6","7","8","9","10","11","12"],
      aliyunOssToken: {},
      varList: [],
      showVarHelp: false,
      priceConfigVisible: false,
      sizeColorVisible: false,
      attrMap: {},
      externalProductIdTypeOptions: [],
      productIds: [{
        name: '按设置生成',
        value: '1'
      },
      {
        name: '不汇出',
        value: '0'
      }],
      itemSkuBefore: '',
      itemSkuAfter: '',
      pictureAddresses: [],
      pId: '',
      sizeConfig: 1600,
      showPicSize: false,
      picSizeH: '',
      picSizeW: '',
      upload: '0'
    };
  },
  watch: {
    templateId: {
      handler(){
        if(this.templateId){
            this.loadData(this.templateId)
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
    handleShowVarHelp(event){
      this.$refs['varHelp'].$el.style.top = event.clientY + 'px'
      this.showVarHelp = true
    },

    getTemplate({ platId, templateId }) {
      this.startLoading()
      getProList({ platId, templateId, templateState: this.basicForm.templateState ? this.basicForm.templateState : undefined }).then(
        (data) => {
          let forms = [];
          let groups = [];
          for (let i = 0; i < data.rows.length; i++) {
            //设置零售价和库存

            if(data.rows[i].fieldName === 'quantity'){
              this.basicForm.quantity = data.rows[i].engValName? data.rows[i].engValName.toString(): ''
            }
             if(data.rows[i].fieldName === 'external_product_id_type'){
              this.externalProductIdTypeOptions = data.rows[i].sPlatProVals
              this.basicForm.external_product_id_type = data.rows[i].engValName
            }
            if(data.rows[i].fieldName === 'external_product_id'){
              this.basicForm.external_product_id = data.rows[i].engValName
            }

            if(data.rows[i].fieldName === 'color_name'){
              this.basicForm.color_name = data.rows[i].engValName
            }

            if(data.rows[i].fieldName === 'relationship_type' && !data.rows[i].engValName){
              data.rows[i].engValName = 'Variation'
            }
             if(data.rows[i].fieldName === 'variation_theme' && !data.rows[i].engValName){
              data.rows[i].engValName = 'Size/Color'
            }
              if(data.rows[i].fieldName === 'footwear_age_group'){
              data.rows[i].engValName = 'Adult'
              // data.rows[i].disabled = true
            }
              if(data.rows[i].fieldName === 'age_range_description'){
              data.rows[i].engValName = 'adult'
              //  data.rows[i].disabled = true
            }


            if(data.rows[i].fieldName === 'item_sku'){
              if(data.rows[i].engValName){
              let fieldValue =  data.rows[i].engValName.split('{id}')
              if(fieldValue && fieldValue.length > 1){
                this.itemSkuBefore = fieldValue[0]
                this.itemSkuAfter = fieldValue[1]
              }
              } else{
                this.itemSkuBefore = ''
                this.itemSkuAfter = ''
              }
            }
            if(data.rows[i].groupBy == "Required"){
              data.rows[i].visible = true;
            }else{
              data.rows[i].visible = false;
            }


            this.attrMap[data.rows[i].attrId] = data.rows[i].fieldName
            if (groups.length == 0) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
              continue;
            }
            let isFind = false;
            for (let j = 0; j < groups.length; j++) {
              for (let k = 0; k < groups[j].length; k++) {
                if (groups[j][k].groupBy === data.rows[i].groupBy) {
                  isFind = true;
                  groups[j].push(data.rows[i]);
                  forms[j][data.rows[i].attrId] = data.rows[i].engValName;
                  break;
                }
              }
            }
            if (!isFind) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
            }
          }
          this.formItems = data.rows;
          this.forms = forms;
          this.groups = groups;
          this.getPicture()
          this.endLoading()
        }
      ).catch(()=>{
        this.endLoading()
      });
    },
    handleCheckAll() {
      if (this.checkedAll) {
        this.templateViews = ["Required", "Optional", "Preferred"];
      } else {
        this.templateViews = ["Required"];
      }
    },
    handleSavePicSize(){
      if(this.sizeConfig == 0){
        if(!this.picSizeW ){
          this.msgError('请输入宽度')
          return
        }
        if(!this.picSizeH){
          this.msgError('请输入高度')
          return
        }
        this.basicForm.picSizeW = this.picSizeW
        this.basicForm.picSizeH = this.picSizeH
      }else if(this.sizeConfig == 1600){
        this.basicForm.picSizeW = '1600'
         this.basicForm.picSizeH = '1600'
      }else if(this.sizeConfig == 800){
        this.basicForm.picSizeW = '800'
         this.basicForm.picSizeH = '800'
      }
      else if(this.sizeConfig == 1200){
        this.basicForm.picSizeW = '1200'
         this.basicForm.picSizeH = '1200'
      }
      else if(this.sizeConfig == 2000){
        this.basicForm.picSizeW = '2000'
        this.basicForm.picSizeH = '2000'
      }
      this.showPicSize = false
    },
    handleSetPrice(value){
      this.basicForm.skuList = value
    },
    async getPlatTypeList(platId) {
      if(!platId){
        platId = this.$route.query.platId
      }
      if(platId){
        let result = await getTemplateTypeList(platId);
        this.platTypeList = result.data;

        let templateId = this.$route.query.templateId
        let pId =  this.$route.query.pId
        let designId =  this.$route.query.designId
        if(this.$route.query.platId && !templateId && !pId && !designId){
          let platCode = this.getChild(this._.clone(result.data))
          this.getTemplate({platId : platCode});
        }
      }
       else{
        let result = await getProductTypeList({platNo: '04'});
        this.platTypeList = result.data;
      }
    },
    handleChangePlatId(value) {
      let vals = this.getCascaderObj(value, this.platTypeList);
      if (vals.length > 0) {
        let node = vals[vals.length - 1];
        // this.feedProductType = node.feedProductType;
        // this.itemType = node.itemType;
        this.getTemplate({platId : node.platId});
      }
    },
    handleChangeState(value){
      let platId = this.$route.query.platId
      if(platId){
        this.getTemplate({platId : platId})
      } else if(this.basicForm.platId && this.basicForm.platId.length > 0){
        this.getTemplate({platId : this.basicForm.platId[this.basicForm.platId.length -1]});
      }
    },
    getChild(tree){
      let platId = ''
      let platIdArray = []
      while(true){
        if(tree[0].childrenTree == null){
          break
        }
        platIdArray.push(tree[0].platId)
        tree = tree[0].childrenTree
      }
      platId = tree[0].platId
      platIdArray.push(platId)
      this.basicForm.platId = platId
      return platId
    },
    getCascaderObj(val, opt) {
      return val.map(function (value, index, array) {
        for (var itm of opt) {
          if (itm.platId == value) {
            opt = itm.childrenTree;
            return itm;
          }
        }
        return null;
      });
    },
    handleSetMainImage(record,index){
      this.imageGroup.map(item=>{
        item.isMain = false
      })
      record.isMain = true
      //插入到第一个元素
      this.imageGroup.splice(index , 1)
      this.imageGroup.unshift(record)
    },
    hanldeDeleteImage(record, index){
      this.imageGroup.splice(index , 1)
      let haveMain = false
      for(let record of this.imageGroup){
        if(record.isMain === true){
          haveMain = true
        }
      }
      if(!haveMain){
        this.imageGroup[0].isMain = true
      }
    },
    handleAddSample(record){
      this.imageGroup.push({
        imageUrl: record,
        isMain: this.imageGroup.length === 0 ? true : false
      })
    },
    handleSave(){
      this.$emit('save')
    },
    handleSaveForm() {
      //验证表单
      console.log(this.$refs)
      this.$refs["basicForm"].validate((valid) => {
        if (valid) {
          this.$refs["form0"][0].validate(async (auth)=>{
            if(!auth){
              return
            }
            if(this.imageGroup.length == 0){
              this.msgError('请设置产品图片')
              return
            }
            if(this.basicForm.saleForm == '04'){
              var thisCount = this.basicForm.color_name.split('{').length - 1
              if(thisCount < 2){
                this.msgError('颜色名称生成规则至少需要两个变量')
                return
              }
            }

            this.startLoading()
            let form = JSON.parse(JSON.stringify(this.basicForm));
            if(!form.picSizeH || !form.picSizeW ){
               form.picSizeH = '1600'
               form.picSizeW = '1600'
            }
            if(typeof(form.platId) === 'object'){
              form.platId = form.platId[form.platId.length - 1];
            }
            //设置图片
            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.groupBy === 'proPicGroup'){
                  for(let j =0;j<this.imageGroup.length;j++){
                    if(j === 0 && item.fieldName === 'main_image_url'){
                      this.forms[i][item.attrId] = this.imageGroup[j].imageUrl
                      break
                    } else if (item.fieldName === 'other_image_url' + j){
                      this.forms[i][item.attrId] = this.imageGroup[j].imageUrl
                      break
                    }
                  }
                }
              }
            }

            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.groupBy === 'proPicGroup'){
                  for(let j =this.imageGroup.length ;j<9;j++){
                    if (item.fieldName === 'other_image_url' + j){
                      this.forms[i][item.attrId] = null
                      break
                    }
                  }
                }
              }
            }
            //设置基础价格
            for (let i=0; i< this.groups.length;i++) {
              for (let item of this.groups[i]) {
                if(item.fieldName === 'external_product_id_type'){
                  this.forms[i][item.attrId] = this.basicForm.external_product_id_type
                  continue
                }
                if(item.fieldName === 'external_product_id'){
                  this.forms[i][item.attrId] = this.basicForm.external_product_id
                  continue
                }
                if(item.fieldName === 'quantity'){
                  this.forms[i][item.attrId] = this.basicForm.quantity
                  continue
                }
                if(item.fieldName === 'item_sku'){
                  let value = this.itemSkuBefore + '{id}' + this.itemSkuAfter
                  this.forms[i][item.attrId] = value
                  continue
                }
                if(item.fieldName === 'color_name'){
                   this.forms[i][item.attrId] = this.basicForm.color_name
                  continue
                }
              }
            }

            //设置提交表单
            for (let record of this.forms) {
              for (let key in record) {
                form.attrList.push({
                  attrId: key,
                  fieldName:  this.attrMap[key],
                  engValName: record[key],
                });
              }
            }
            let action = this.$route.query.action
            let templateId = this.$route.query.templateId
            if(templateId && action === 'edit'){
              form.templateId = templateId
            }else{
              form.templateId = null
            }
            form.codeType = this.basicForm.external_product_id_type
            //
            try {
               if(this.templateId){
                form.templateId = this.templateId
                form.shopId = this.shopId

                if(this.pId){
                  form.pId = this.pId
                  await addAmazonRemit(form)
                  this.msgSuccess("汇出成功，请到汇出记录中下载");
                }

                if(this.designId){
                  form.designId = this.designId
                  await addRemit(form)
                  this.msgSuccess("汇出成功，请到汇出记录中下载");
                }
              }
              else{
                await addTemplate(form);
                 this.msgSuccess("保存成功");
              }
              this.endLoading()
              this.$emit('submit')
            } catch (error) {
              this.endLoading()
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getPicture(){
      this.imageGroup = []
      for (let record of this.groups) {
        for (let i=0;i< record.length;i++) {
          if(record[i].groupBy === 'proPicGroup' && record[i].fieldName === 'main_image_url' && record[i].engValName){
            this.imageGroup.push({
              imageUrl: record[i].engValName,
              isMain: true
            })
          } else if(record[i].groupBy === 'proPicGroup' && record[i].engValName){
             this.imageGroup.push({
              imageUrl: record[i].engValName,
              isMain: false
            })
          }
        }
      }
    },
    getTreeNode(id ,list){
      let _this=this
      for (let i = 0; i < list.length; i++) {
        let node=list[i]
        if(node.platId=== id){
          return node
        } else{
          if(node.childrenTree && node.childrenTree.length>0){
            let res=_this.getTreeNode(id, node.childrenTree)
            if(res){
              return res
            }
          }
        }
      }
    },
    handleLoadTemplate(){

    },
    async loadData(templateId){
      if(templateId){
        let result = await getTemplateInfo(templateId)
        result.data.price = ''
        result.data.quantity = ''
        result.data.external_product_id_type = ''
        result.data.external_product_id = ''
        result.data.color_name = ''
        result.data.colorList = []
        result.data.sizeList = []
        if(!result.data.saleForm){
          result.data.saleForm = '03'
        }
        this.basicForm = result.data


        if(!this.basicForm.attrList){
          this.basicForm.attrList = []
        }
        if(this.basicForm.picSizeW && this.basicForm.picSizeH ){
          if(this.basicForm.picSizeW == 1600 && this.basicForm.picSizeH  == 1600){
            this.sizeConfig = 1600
          } else if(this.basicForm.picSizeW == 800 && this.basicForm.picSizeH  == 800){
            this.sizeConfig = 800
          }else if(this.basicForm.picSizeW == 1200 && this.basicForm.picSizeH  == 1200){
            this.sizeConfig = 1200
          }else if(this.basicForm.picSizeW == 2000 && this.basicForm.picSizeH  == 2000){
            this.sizeConfig = 2000
          } else{
            this.sizeConfig = 0
            this.picSizeW = this.basicForm.picSizeW
            this.picSizeH = this.basicForm.picSizeH
          }
        } else {
          this.sizeConfig = 1600
          this.basicForm.picSizeW = 1600
          this.basicForm.picSizeH = 1600
        }

        await this.getPlatTypeList(result.data.platId);
        result = await this.getTemplate({templateId})
      }else{
        await this.getPlatTypeList();
      }
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if(designId){
        let result = await listDesignColorsize({
          templateId: templateId,
          designId: designId,
        })
        this.basicForm.colorList = result.data.colorList
        this.basicForm.sizeList = result.data.sizeList
      }
      if(pId){
        let result = await listAmazonColorsize({
          templateId: this.templateId,
          pId: pId,
        })
        this.basicForm.colorList = result.data.colorList
        this.basicForm.sizeList = result.data.sizeList
      }

      // let node = this.getTreeNode(this.basicForm.platId, this.platTypeList);
      // this.feedProductType = node.feedProductType;
      // this.itemType = node.itemType;
    },
     getEditorRemarks(value){
        this.editorRemarks = value
      },
        handleChangeEditor(value){
        // this.form.remarks = value
      },
    //获取上传通行证
    getOssToken() {
      var _self = this
      getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
    handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.imageGroup.push({
              imageUrl: fileUrl,
              isMain: _self.imageGroup.length === 0 ? true : false
            })
            $("#fileUpload").val(null)
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
    handleUploadImage(){
      document.querySelector('#fileUpload').click()
    },
    handleBackTop(){
      window.scroll(0,0)
    },
    handleInsertVariable(forms,index,attrId, value){
      this.insertAtCursor(forms,index,attrId, value)
      // forms[index][attrId] = (forms[index][attrId] ? forms[index][attrId] : '') + value
      // this.$refs['textarea_' + attrId][0].focus()
      // document.querySelector('.variable-select-menu').style.display = 'block'
    },
    async insertAtCursor(forms,index,attrId, value) {
      var myValue = value
      const myField = document.querySelector('#textarea_' + attrId)
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        forms[index][attrId] = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        forms[index][attrId] = (forms[index][attrId] ? forms[index][attrId] : '') + value
      }
    },
    async handleInsertColorSize(value){
      var myValue = value
      const myField = document.querySelector('#textarea_color')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.basicForm.color_name = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length)
        await this.$nextTick() // 这句是重点, 圈起来,不加的话后面两步有问题
        myField.focus()
        myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length)
      } else {
        this.basicForm.color_name = (this.basicForm.color_name ? this.basicForm.color_name : '') + value
      }
    },
    async getVarList(){
      let pId = this.$route.query.pId
      let designId = this.$route.query.designId
      if (pId) {
        let result = await getVarListColl()
        this.varList = result.rows
      }  else if(designId) {
        let result = await getVarListDesign()
        this.varList = result.rows
      }else {
          let result = await getVarList()
        this.varList = result.rows
      }
    },
    onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
    },
    handleChangeProductType(){
      this.basicForm.external_product_id = '0'
      if(this.basicForm.external_product_id_type == "EAN" || this.basicForm.external_product_id_type == "UPC"){
        this.productIds = [{
          name: '按设置生成',
          value: '1'
        },
        {
          name: '不汇出',
          value: '0'
        }]
      }else{
        this.productIds =  [
        {
        name: '不汇出',
        value: '0'
         }]
      }
    },
    getConfigKey(){
      var _self = this
      getConfigKey("pic_url")
        .then(async (res) => {
          if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            debugger
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleSetColorSize(record){
      this.basicForm.colorList = record.colorList
      this.basicForm.sizeList = record.sizeList
    }
 },
 async mounted() {
    let templateId = this.$route.query.templateId
    let pId =  this.$route.query.pId

    let designId =  this.$route.query.designId
    let upload =  this.$route.query.upload
    this.pId = pId
    this.upload = upload
    if(templateId){
      this.loadData(templateId)
    }
    this.getOssToken()
    this.getVarList()
    this.getConfigKey()
    if(!pId && !templateId && !designId){
      this.getPlatTypeList('')
    }

  },
};
</script>

<style lang="scss" scoped>
#main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #409eff;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 80%;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  li.sort-img-item {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > div > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > div > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  li.add-image-button > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope,
  .detail-image-ul.lazada > div > li .wish-product-img-ope,
  .wish-product-img > div > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: #3ba5ea;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > div > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > div > li .wish-product-img-ope > a,
  .wish-product-img > div > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: rgb(255, 165, 79);
    font-weight: bold;
    font-size: 14px;
    top: -8px;
    left: 0;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
  }
  .add-image-button {
    font-size: 24px;
    vertical-align: 15px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #409eff;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #409eff;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  right: 0;
  text-align: right;
  top: 20px;
  line-height: 20px;
}
.com-search-input {
  height: 28px;
  border: 1px solid rgb(225, 227, 229);
  vertical-align: top;
}
select {
  color: rgb(89, 90, 90);
  border-radius: 4px;
  width: 100%;
}

.wd600 {
  width: 600px;
}

input:focus,
textarea:focus,
select:focus,
textarea:focus {
  border: 1px solid #409eff;
  box-shadow: 0 0 2px #a3c3f9;
  outline: none;
}
.w70 {
  width: 70% !important;
}
.w100 {
  width: 100% !important;
}
.imgSize-box {
  background: #fff;
  border: 1px solid rgb(221, 221, 221);
  min-width: 160px;
  p {
    padding: 7px 10px;
    font-size: 12px;
    line-height: 26px;
  }
  .ml5 {
    margin-left: 5px !important;
  }
}
.pro_vid_box .st_el {
  font-size: 60px;
  color: rgb(89, 89, 89);
}
.pro_vid_box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 110px;
  height: 110px;
  border: 1px dashed #bcbcbc;
  cursor: initial;
}
.mr_20 {
  margin-right: 20px !important;
}
.flex {
  display: flex;
}
.f_gray {
  color: #919099;
}
.wd200 {
  width: 200px;
}
.mr8{
  margin-right: 8px;
}
</style>
